<!-- {{isAdmin()}}
{{isBusinessOwner()}} -->
<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Holidays</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a [routerLink]="[getDashboardRoute()]"><i class="ti ti-smart-home"></i></a>
          </li>
          <!-- <li class="breadcrumb-item">
              Employee
            </li> -->
          <li class="breadcrumb-item active" aria-current="page">Holidays</li>
        </ol>
      </nav>
    </div>
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
      <div class="mb-2">
        <button
          (click)="openBusiness(addBusinessModal)"
          *appHasPermission="{ holidays: ['edit'] }"
          class="btn btn-primary d-flex align-items-center"
        >
          <i class="ti ti-circle-plus me-2"></i>Add Holiday
        </button>
      </div>

      <div class="head-icons ms-2 d-none">
        <a
          href="javascript:void(0);"
          class=""
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          data-bs-original-title="Collapse"
          id="collapse-header"
        >
          <i class="ti ti-chevrons-up"></i>
        </a>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
      <h5>Holidays List</h5>
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
        <div class="me-3" *ngIf="holidayList.length > 0">
          <select
            class="form-select form-select-sm col-md-1"
            id="entries"
            [(ngModel)]="pageLimit"
            (change)="onPageLimitChange()"
          >
            <!-- <option selected disabled>Show Entries Per Page</option> -->
            <option *ngFor="let limit of [10, 20, 50, 100]" [value]="limit">{{ limit }}</option>
          </select>
        </div>

        <div class="dropdown me-3" *appHasPermission="{ business: ['view'] }">
          <!-- <select class="form-select" [(ngModel)]="selectedBusiness" (change)="getHolidaysList()">
            <option value="" selected>Select Business Entity</option>
            <option *ngFor="let business of businesses$ | async" [value]="business.id">
              {{ business.businessName | capitalize }}
            </option>
          </select> -->
          <ng-select
            class=""
            [items]="businesses$ | async"
            bindValue="id"
            placeholder="Select Business Entity"
            [searchable]="true"
            [clearable]="true"
            [searchFn]="customSearchFnBusiness"
            style="width: 200px"
            [(ngModel)]="selectedBusiness"
            (change)="onFilterBusinessChange($event)"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.businessName | capitalize }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              {{ item.businessName | capitalize }}
            </ng-template>
          </ng-select>
        </div>

        <!-- this code is added by shivam 13-4-2026 -->
        <div class="dropdown me-3" *appHasPermission="{ business: ['view'] }">
          <ng-select
            [items]="offices$ | async"
            placeholder="Select Office"
            [searchable]="true"
            [clearable]="true"
            [searchFn]="customSearchFnOffice"
            [disabled]="!selectedBusiness"
            style="width: 200px"
            [(ngModel)]="selectedOffice"
            (change)="onOfficeChange($event)"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.officeName | capitalize }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              {{ item.officeName | capitalize }}
            </ng-template>
          </ng-select>
        </div>
        <!-- <div class="form-sort me-3">
          <label>
            <input
              type="number"
              [(ngModel)]="searchYear"
              (input)="onYearInput($event)"
              class="form-control"
              placeholder="Enter year"
              min="1900"
              step="1"
              maxlength="4"
            />
          </label>
        </div> -->
        <!-- <div class="me-3">
          <div class="input-icon position-relative">
            <span class="input-icon-addon">
              <i class="ti ti-calendar text-gray-9"></i>
            </span>
            <input
              type="text"
              id="holidaySingleDate"
              class="form-control date-range bookingrange"
              placeholder="dd/mm/yyyy"
              readonly
            />
          </div>
        </div> -->
        <div class="me-3">
          <div class="year-select">
            <div class="selected-box" (click)="toggleDropdown()">
              {{ searchYear }}
            </div>

            <div class="year-dropdown-panel" *ngIf="isOpen">
              <div class="top-bar">
                <button class="nav-btn" (click)="prevYearPage()">‹</button>
                <span>{{ years[0] }} - {{ years[years.length - 1] }}</span>
                <button class="nav-btn" (click)="nextYearPage()">›</button>
              </div>

              <div class="year-grid">
                <button
                  *ngFor="let y of years"
                  (click)="selectYear(y)"
                  [class.active]="y === searchYear"
                >
                  {{ y }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="form-sort me-5">
          <input
            type="search"
            [(ngModel)]="search"
            (ngModelChange)="onSearchChange($event)"
            class="form-control"
            placeholder="Search"
          />
        </div>
      </div>
    </div>
    <div class="card-body p-0">
      <div class="custom-datatable-filter table-responsive">
        <table class="table datatable" *ngIf="holidayList.length > 0; else noRecords">
          <thead class="thead-light">
            <tr>
              <!-- <th class="no-sort">
                  <div class="form-check form-check-md">
                    <input class="form-check-input" type="checkbox" id="select-all">
                  </div>
                </th> -->
              <th>Title</th>
              <th>Date</th>
              <th>Description</th>
              <th *ngIf="isAdmin() || isBusinessOwner()">Business Entity</th>
              <th *ngIf="isAdmin() || isBusinessOwner()">Office</th>
              <!-- <th>Status</th> -->
              <th *appHasPermission="{ holidays: ['edit', 'delete'] }">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let holiday of holidayList">
              <!-- <td>
                  <div class="form-check form-check-md">
                    <input class="form-check-input" type="checkbox">
                  </div>
                </td> -->
              <td>
                <h6 class="fw-medium">
                  {{ holiday.title }}
                </h6>
              </td>
              <!-- <td>{{ holiday.startDate | date: 'EEE, dd MMM yyyy' }}{{ holiday.endDate != holiday.startDate ? to holiday.endDate | date: 'EEE, dd MMM yyyy' : ''}}</td> -->
              <td>
                {{ holiday.date | date: 'EEE, dd MMM yyyy' }}
                <!-- <span *ngIf="holiday.endDate !== holiday.startDate"> <strong>to</strong> {{ holiday.endDate | date: 'EEE, dd MMM yyyy' }}</span> -->
              </td>
              <td>{{ holiday.description }}</td>
              <!-- <td *ngIf="user?.userRole?.id === 1 || user?.userRole?.id === 2">
                {{ getBusinessName(holiday.businessId) | capitalize }}
              </td> -->
              <td *ngIf="isAdmin() || isBusinessOwner()">
                {{ holiday.business?.businessName }}
              </td>
              <td *ngIf="isAdmin() || isBusinessOwner()">
                {{ holiday.office?.officeName }}
              </td>
              <!-- <td>
                  <span *ngIf="holiday.status == 'Active'"
                    class="badge badge-success d-inline-flex align-items-center badge-xs">
                    <i class="ti ti-point-filled me-1"></i>Active
                  </span>
                  <span *ngIf="holiday.status != 'Active'"
                    class="badge badge-danger d-inline-flex align-items-center badge-xs">
                    <i class="ti ti-point-filled me-1"></i>Inactive
                  </span>
                </td> -->
              <td *appHasPermission="{ holidays: ['edit', 'delete'] }">
                <div class="action-icon d-inline-flex" *ngIf="!isHolidayPassed(holiday)">
                  <a
                    href="javascript:void(0);"
                    class="me-2"
                    (click)="openEditHoliday(editHolidayModal, holiday)"
                    *appHasPermission="{ holidays: ['edit'] }"
                    ><i class="ti ti-edit"></i
                  ></a>
                  <!-- <a href="javascript:void(0);" class="me-2"
                      (click)="openBlockUnblock(blockunblockModal, holiday.id, holiday.title , holiday.status)"><i
                        [ngClass]="holiday.status == 'Inactive' ? 'ti ti-lock' : 'ti ti-lock-open-2'"></i></a> -->

                  <a
                    href="javascript:void(0);"
                    (click)="openDelete(deleteModal, holiday.id)"
                    *appHasPermission="{ holidays: ['delete'] }"
                    ><i class="ti ti-trash"></i
                  ></a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <ng-template #noRecords>
          <div class="text-center">Record not available</div>
        </ng-template>
      </div>
    </div>
    <!-- <div class="has-text-centered mt-3" *ngIf="holidayList.length > 0">
        <app-pagination [currentPage]="currentPage" [pageSize]="pageLimit" [totalRows]="totalCount"
          (pageChange)="onPageChange($event)"></app-pagination>
      </div> -->
    <div
      class="d-flex align-items-center justify-content-between ms-2"
      *ngIf="holidayList.length > 0"
    >
      <div>
        Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
        {{ totalCount }} entries
      </div>
      <div class="has-text-centered mt-3">
        <app-pagination
          [currentPage]="currentPage"
          [pageSize]="pageLimit"
          [totalRows]="totalCount"
          (pageChange)="onPageChange($event)"
        ></app-pagination>
      </div>
    </div>
  </div>
</div>

<!-- Add Holiday -->
<ng-template #addBusinessModal let-modal>
  <!-- <div class="modal fade" id="add_holiday">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content"> -->
  <div class="modal-header">
    <h4 class="modal-title">Add Holiday</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <form [formGroup]="form">
    <div class="modal-body pb-0">
      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <label for="title" class="form-label">Title <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="title" appTrimInput />
            <div *ngIf="form.get('title')?.invalid && form.get('title')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('title') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <label for="date" class="form-label">Date <span class="text-danger">*</span></label>
            <!-- <div class="input-icon-end position-relative"> -->
            <input
              type="date"
              class="form-control datetimepicker"
              placeholder="dd/mm/yyyy"
              formControlName="date"
              appTrimInput
            />
            <!-- <span class="input-icon-addon">
                  <i class="ti ti-calendar text-gray-7"></i>
                </span> -->
            <!-- </div> -->
            <div *ngIf="form.get('date')?.invalid && form.get('date')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('date') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <div class="input-block mb-3">
              <label for="businessId" class="col-form-label"
                >Business Entity <span class="text-danger">*</span></label
              >
              <!-- <select
                class="form-select"
                formControlName="businessId"
                [(ngModel)]="selectedBusinessId"
                (change)="onBusinessChange(selectedBusinessId)"
              >
                <option disabled selected>Select Business Entity</option>
                <option *ngFor="let business of businesses$ | async" [value]="business.id">
                  {{ business.businessName | capitalize }}
                </option>
              </select> -->
              <ng-select
                class="me-3 w-100"
                [items]="businesses$ | async"
                bindValue="id"
                placeholder="Select Business Entity"
                [searchable]="true"
                [clearable]="true"
                [searchFn]="customSearchFnBusiness"
                style="width: 200px"
                formControlName="businessId"
                [(ngModel)]="selectedBusinessId"
                (change)="onBusinessChange(selectedBusinessId)"
              >
                <ng-template ng-label-tmp let-item="item">
                  {{ item.businessName | capitalize }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  {{ item.businessName | capitalize }}
                </ng-template>
              </ng-select>
              <div *ngIf="form.get('businessId')?.invalid && form.get('businessId')?.touched">
                <span class="text-danger">
                  {{ getErrorMessage('businessId') }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="input-block mb-3">
            <label class="col-form-label" for="offices">
              Offices <span class="text-danger">*</span>
            </label>
            <!-- <select class="form-select" multiple formControlName="offices" data-extension-safe>
              <option value="">All Offices</option>
              <option *ngFor="let office of offices$ | async" [value]="office.id">
                {{ office.officeName | capitalize }}
              </option>
            </select> -->
            <ng-select
              class="me-3 w-100"
              multiple
              [items]="offices$ | async"
              bindValue="id"
              placeholder="Select Office"
              [searchable]="true"
              [clearable]="true"
              [searchFn]="customSearchFnOffice"
              style="width: 200px"
              formControlName="offices"
            >
              <ng-template ng-label-tmp let-item="item">
                {{ item.officeName | capitalize }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ item.officeName | capitalize }}
              </ng-template>
            </ng-select>
            <div *ngIf="form.get('offices')?.invalid && form.get('offices')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('offices') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <label for="description" class="form-label">Description</label>
            <textarea
              class="form-control"
              rows="3"
              formControlName="description"
              appTrimInput
            ></textarea>
          </div>
        </div>
        <input type="hidden" formControlName="disabled" />
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal" (click)="onClose()">
        Cancel
      </button>
      <button type="submit" class="btn btn-primary" (click)="onSubmit()" [disabled]="!form.valid">
        Add Holiday
      </button>
    </div>
  </form>
  <!-- </div>
    </div>
  </div> -->
</ng-template>
<!-- /Add Holiday -->

<!-- Add Holiday -->
<ng-template #editHolidayModal let-modal>
  <!-- <div class="modal fade" id="add_holiday">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content"> -->
  <div class="modal-header">
    <h4 class="modal-title">Edit Holiday</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <form [formGroup]="form">
    <div class="modal-body pb-0">
      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <label for="title" class="form-label">Title <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="title" appTrimInput />
            <div *ngIf="form.get('title')?.invalid && form.get('title')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('title') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <label for="date" class="form-label">Date <span class="text-danger">*</span></label>
            <!-- <div class="input-icon-end position-relative"> -->
            <input
              type="date"
              class="form-control datetimepicker"
              placeholder="dd/mm/yyyy"
              formControlName="date"
            />
            <!-- <span class="input-icon-addon">
                  <i class="ti ti-calendar text-gray-7"></i>
                </span> -->
            <!-- </div> -->
            <div *ngIf="form.get('date')?.invalid && form.get('date')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('date') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <div class="input-block mb-3">
              <label for="businessId" class="col-form-label"
                >Business Entity <span class="text-danger">*</span></label
              >
              <!-- <select class="form-select" formControlName="businessId">
                <option disabled selected>Select Business Entity</option>
                <option *ngFor="let business of businesses$ | async" [value]="business.id">
                  {{ business.businessName | capitalize }}
                </option>
              </select> -->
              <ng-select
                class="me-3 w-100"
                [items]="businesses$ | async"
                bindValue="id"
                placeholder="Select Business Entity"
                [searchable]="true"
                [clearable]="true"
                [searchFn]="customSearchFnBusiness"
                style="width: 200px"
                formControlName="businessId"
              >
                <ng-template ng-label-tmp let-item="item">
                  {{ item.businessName | capitalize }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  {{ item.businessName | capitalize }}
                </ng-template>
              </ng-select>
              <div *ngIf="form.get('businessId')?.invalid && form.get('businessId')?.touched">
                <span class="text-danger">
                  {{ getErrorMessage('businessId') }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="input-block mb-3">
            <label class="col-form-label" for="offices">
              Offices <span class="text-danger">*</span>
            </label>
            <!-- <select class="form-select" multiple formControlName="offices" data-extension-safe>
              <option value="">All Offices</option>
              <option *ngFor="let office of offices$ | async" [value]="office.id">
                {{ office.officeName | capitalize }}
              </option>
            </select> -->
            <ng-select
              class="me-3 w-100"
              multiple
              [items]="offices$ | async"
              bindValue="id"
              placeholder="Select Office"
              [searchable]="true"
              [clearable]="true"
              [searchFn]="customSearchFnOffice"
              style="width: 200px"
              formControlName="offices"
            >
              <ng-template ng-label-tmp let-item="item">
                {{ item.officeName | capitalize }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ item.officeName | capitalize }}
              </ng-template>
            </ng-select>
            <div *ngIf="form.get('offices')?.invalid && form.get('offices')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('offices') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <label for="description" class="form-label">Description</label>
            <textarea
              class="form-control"
              rows="3"
              formControlName="description"
              appTrimInput
            ></textarea>
            <div *ngIf="form.get('description')?.invalid && form.get('description')?.touched">
              <span class="text-danger">
                {{ getErrorMessage('description') }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-12 d-none">
          <div class="mb-3">
            <label for="disabled" class="form-label">Status</label>
            <select class="form-select" formControlName="disabled">
              <option [value]="false">Active</option>
              <option [value]="true">Inactive</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal" (click)="onClose()">
        Cancel
      </button>
      <button type="submit" class="btn btn-primary" (click)="onSubmit()" [disabled]="!form.valid">
        Update Holiday
      </button>
    </div>
  </form>
  <!-- </div>
    </div>
  </div> -->
</ng-template>
<!-- /Add Holiday -->

<!-- block unblock Modal -->
<ng-template #blockunblockModal let-modal>
  <!-- <div class="modal fade" id="delete_modal">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content"> -->
  <div class="modal-body text-center">
    <span
      class="avatar avatar-xl mb-3"
      [ngClass]="
        blockUnblockStatus !== 'Active'
          ? 'bg-transparent-danger text-danger'
          : 'bg-transparent-success text-success'
      "
    >
      <i
        [ngClass]="blockUnblockStatus !== 'Active' ? 'ti ti-lock fs-36' : 'ti ti-lock-open-2 fs-36'"
      ></i>
    </span>
    <h4 class="mb-1">Confirm {{ blockUnblockStatus }}</h4>
    <p class="mb-3">
      You want to {{ blockUnblockStatus !== 'Active' ? 'De-activate' : 'Activate' }} the
      <strong>{{ blockTilte }}</strong
      >.
    </p>
    <div class="d-flex justify-content-center">
      <a
        href="javascript:void(0);"
        class="btn btn-light me-3"
        data-bs-dismiss="modal"
        (click)="onClose()"
        >Cancel</a
      >
      <a href="javascript:void(0);" class="btn btn-danger" (click)="confirmBlockUnblock()"
        >Yes, {{ blockUnblockStatus !== 'Active' ? 'De-activate' : 'Activate' }}</a
      >
    </div>
  </div>
  <!-- </div>
    </div>
  </div> -->
</ng-template>
<!-- /block unblock Modal -->

<!-- Delete Modal -->
<ng-template #deleteModal let-modal>
  <!-- <div class="modal fade" id="delete_modal">
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content"> -->
  <div class="modal-body text-center">
    <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
      <i class="ti ti-trash-x fs-36"></i>
    </span>
    <h4 class="mb-1">Confirm Delete</h4>
    <p class="mb-3">You want to delete the holiday, this can't be undone once you delete.</p>
    <div class="d-flex justify-content-center">
      <a
        href="javascript:void(0);"
        class="btn btn-light me-3"
        data-bs-dismiss="modal"
        (click)="onClose()"
        >Cancel</a
      >
      <a href="javascript:void(0);" class="btn btn-danger" (click)="confirmDelete()">Yes, Delete</a>
    </div>
  </div>
  <!-- </div>
  </div>
  </div> -->
</ng-template>
<!-- /Delete Modal -->
